import { Box, Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import bg from "../../Assets/Login.webp";
import { useFormik } from "formik";
import * as yup from "yup";
import logo from "../../Assets/logo.webp";
import ButtonComponent from "../../Component/ButtonComponent";
import { useNavigate } from "react-router-dom";
import PathList from "../../Common/PathList";
import { API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { toast } from "react-toastify";

function Login() {
  const [loginScreen, setLoginScreen] = useState(true);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: yup.object({
      email: yup.string().email("Invalid email").required("Required"),
      password: loginScreen
        ? yup
          .string()
          .required("Required")
          .min(6, "Required at least 6 digits.")
        : yup.string().notRequired(),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      const f = new FormData();
      f.append("email", values.email);
      if (loginScreen)
      {
        f.append("password", values.password);
        let res = await API_POST(API_endspoints.login, f);
        if (res.s && res.r.role == 3)
        {
          toast.success("Login Successfully");
          localStorage.setItem("cateringFiestaInfo", JSON.stringify(res.r));
          navigate(PathList._Dashboard);
        } else if (res.s)
        {
          toast.error("you are not authenticated");
        } else
        {
          toast.error(res.m);
        }
        setSubmitting(false);
      } else
      {
        let res = await API_POST(API_endspoints.forgot, f);
        if (res.s)
        {
          toast.success(res.m);
        } else if (res.s)
        {
          toast.error("you are not authenticated");
        } else
        {
          toast.error(res.m);
        }
      }
    },
  });

  return (
    <Box
      sx={{
        background: `linear-gradient(#d2d2d250,#00000050),url(${bg}) center center / cover`,
        height: "100vh",
        width: "100%",
        padding: "1rem",
      }}
      className="flexCenter"
    >
      <Box
        sx={{
          borderRadius: "25px",
          maxWidth: "500px",
          width: { xs: "100%", md: "50%" },
          padding: { xs: "1rem", md: "2rem" },
          backgroundColor: "white",
        }}
      >
        <Box className="flexCenter">
          <Box
            sx={{
              height: "140px",
              width: "200px",
            }}
          >
            <img src={logo} style={{ height: "100%", width: "100%" }} alt="" />
          </Box>
        </Box>

        <Box>
          <Box sx={{ width: "100%" }}>
            <Box>Email</Box>
            <TextField
              type="email"
              id="email"
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              variant="outlined"
              fullWidth
              InputProps={{
                sx: {
                  borderRadius: "12px",
                  color: "#000",
                  "&:hover": {
                    color: "#F57C00",
                    bgcolor: "#FFF3E8",
                    borderRadius: "12px",
                  },
                },
              }}
              sx={{
                margin: "0.5rem 0",
                ".MuiInputBase-root": {
                  borderRadius: "11px",
                },
                ".MuiOutlinedInput-input:focus": {
                  outline: "none",
                },
              }}
              placeholder="admin@gmail.com"
            />
          </Box>

          {loginScreen && (
            <Box sx={{ width: "100%" }}>
              <Box>Password</Box>
              <TextField
                type="password"
                id="password"
                name="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                variant="outlined"
                fullWidth
                InputProps={{
                  sx: {
                    borderRadius: "12px",
                    color: "#000",
                    outline: "none",
                    "&.fieldset": {
                      outline: "none",
                    },
                    "&:hover": {
                      color: "#F57C00",
                      bgcolor: "#FFF3E8",
                      borderRadius: "12px",
                    },
                  },
                }}
                sx={{
                  margin: "0.5rem 0",
                  ".MuiInputBase-root": {
                    borderRadius: "11px",
                  },
                  ".MuiOutlinedInput-input:focus": {
                    outline: "none",
                  },
                }}
                placeholder="*********"
                onKeyDown={(e) => {
                  if (e.key === "Enter")
                  {
                    formik.handleSubmit();
                  }
                }}
              />
            </Box>
          )}
          {loginScreen ? (
            <Box
              sx={{
                padding: "1rem 0.25rem",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <span
                style={{ cursor: "pointer" }}
                onClick={() => setLoginScreen(false)}
              >
                Forgot password ?
              </span>
            </Box>
          ) : (
            <Button
              variant="text"
              onClick={() => setLoginScreen(true)}
              sx={{ textTransform: "none", paddingBottom: "1rem" }}
            >
              Back to login
            </Button>
          )}
          <Box className="flexCenter">
            <ButtonComponent
              disabled={formik.isSubmitting}
              onClick={formik.handleSubmit}
              label={
                formik.isSubmitting ? (
                  <CircularProgress />
                ) : loginScreen ? (
                  "Login"
                ) : (
                  "Submit"
                )
              }
              sx={{
                width: { xs: "100%", md: "150px" },
                textTransform: "none",
                borderRadius: "22px",
                background: `#164FA1`,
                color: "#fff",
                "&:hover": {
                  background: `#164FA1`,
                  color: "#fff",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
